<template>
  <div style="font-size:14px">
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="bottom">
      <!--<b-navbar-brand href="#">SecMail</b-navbar-brand>-->

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        
          <b-navbar-nav v-if="Session != null && Session.IsLoggedIn && $route.path == '/read'">
            <b-nav-item href="#" class="active" @click="GS.ShowSettings = !GS.ShowSettings">{{(GS.ShowSettings ? LanguageStrings[DisplayLanguage]['nav_back'] : LanguageStrings[DisplayLanguage]['nav_settings'])}}</b-nav-item>
            <!--<b-nav-item href="#">{{LanguageStrings[DisplayLanguage]['nav_disclaimer']}}</b-nav-item>-->
          </b-navbar-nav>
        
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown class="active" dropup text="Language" right>
            <b-dropdown-item href="#" @click="switchLanguage('de')">Deutsch</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('en')">English</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('es')">Español</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('fr')">Français</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('it')">Italiano</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('nl')">Nederlands</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('pl')">Polski</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('pt')">Português</b-dropdown-item>
            <b-dropdown-item href="#" @click="switchLanguage('zh')">中国</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="Session != null && Session.IsLoggedIn" @click="logout" href="#" class="active" right>{{LanguageStrings[DisplayLanguage]['nav_logout']}}</b-nav-item>
          <!--
            <b-nav-item-dropdown right>

              <template v-slot:button-content>
                <em>User</em>
              </template>
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item href="#">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>-->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import axios from "axios";



export default {
  name: "BottomNav",
  components: {},
  data: function() {
    return {};
  },
  mounted: function() {},
  computed: {},
  methods: {
    switchLanguage: function(lang) {
      this.GS.Language = lang;
      if (this.Session != null) {
        axios
          .post(
            this.GS.Endpoint +
              "/v2/changelanguage/" +
              this.Session.SessionId +
              "/" +
              lang,
            {},
            {}
          )
          .then(function(response) {})
          .catch(function(response) {});
      }
    },
    logout: function()
    {
      if (this.Session != null) {
        axios
          .post(
            this.GS.Endpoint +
              "/v2/logout/" +
              this.Session.SessionId,
            {},
            {}
          )
          .then(function(response) {})
          .catch(function(response) {});
      }
      this.GS.Session.IsLoggedIn = false;
      this.$router.push("/login");
    },
  }
};
</script>

<style scoped>
</style>
